import { MicrofrontendPrefix } from '../core/enums/microfrontend-prefix.enum';
import { ServiceInfo } from '../interfaces/service-info.interface';

export function getServiceVersion(
    services: ServiceInfo[],
    servicePrefix: MicrofrontendPrefix,
): string | null {
    const mainFrontendServiceInfo = services.find(
        service => service.servicePrefix === servicePrefix,
    );

    return mainFrontendServiceInfo
        ? mainFrontendServiceInfo.version.version
        : null;
}
